const baseInput = {
  borderColor: 'coolGrey.100',
  borderWidth: '1px',
  borderStyle: 'solid',
};

const input = {
  products: {
    chart: baseInput,
    chartblog: baseInput,
    co: baseInput,
    edu: baseInput,
    scale: baseInput,
    spark: baseInput,
  },
};

export default input;
